import React, { useState, useEffect } from "react";
import Header from "../../Components/Header";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import FrenchiseeDocumentDetailsPreview from "./FrenchiseeDocumentDetailsPreview";
import FrenchiseeApplicationStatusComp from "./FrenchiseeApplicationStatusComp";
import { Frenchisee } from "../../../src/Configuration/Frenchisee_URL";
import { decryptData } from "../../CommonMethhods/CommonMethods";
import { toast } from "react-toastify";
import axiosInstance from "../../CommonMethhods/axiosInstance";


function FrenchiseeApplicationStatus(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const [frenchiseeDatails, setFrenchiseeDatails] = useState([])
  const [loader, setLoader] = useState(true);
  if (storeToken == null) {
    window.location.replace("/");
  }

  const getFrenchiseeId = async () => {
    let id = localStorage.getItem("frenchiseeId")
    try {
      const getDetail = await axiosInstance.get(
        `${Frenchisee.GET_FRENCHISEE_ID}?id=${id}`,
      );
      const res = decryptData(getDetail.data);
      let getIdResp = JSON.parse(res)
      
      if (getIdResp?.status === 0) {
        setFrenchiseeDatails(getIdResp.data.info);
      }else{
        toast.error(getIdResp?.message);
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }
    finally {
      setLoader(false);
    }
  };


  useEffect(() => {
    getFrenchiseeId();
  }, []);

  return (
    <>
      <Header headerDetails={frenchiseeDatails} portal={"RM"} />
      <SingleSignOnSideBar />

      <main id="main-content" >
        <FrenchiseeApplicationStatusComp frenchiseeDatails={frenchiseeDatails} loader={loader} />

        <FrenchiseeDocumentDetailsPreview frenchiseeDatails={frenchiseeDatails} />

      </main>
    </>
  );
}

export default FrenchiseeApplicationStatus;
